import axios from "axios";
import { StatisticsURL } from "../Services";
import { authenticatedHeader } from "../DefaultConfig";
import { HideAwaiting, ShowAwaiting } from "../../util/Awaiting";

export async function ClusterDetailAPI(id: number) {
  ShowAwaiting();
  var res = await axios.get(
    StatisticsURL + "api/keyword/following/cluster/" + id.toString(),
    authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}
